import { defineStore } from "pinia";
import CALLBACK_REQUEST_AVAILABLE_AT from "./callbackRequestAvailableAt.graphql";

export const CALLBACK_REQUEST_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;

export const useCallbackRequestStore = defineStore("callbackRequest", {
  state: () => ({
    availableAt: null,
    loaded: false,
    loading: false,
  }),
  getters: {
    isOnCooldown: (state) =>
      !!state.availableAt && new Date(state.availableAt) > new Date(),
  },
  actions: {
    async load(context, { force = false } = {}) {
      if (this.loading || (this.loaded && !force)) {
        return;
      }
      try {
        this.loading = true;
        const result = await context.$query(
          CALLBACK_REQUEST_AVAILABLE_AT,
          {},
          { skipErrorPageOnAuthError: true }
        );
        this.availableAt = result.callbackRequestAvailableAt;
        this.loaded = true;
      } catch (err) {
        context.$logger.warn(
          "Failed to load callback request availability",
          err
        );
      } finally {
        this.loading = false;
      }
    },
    markRequested() {
      this.availableAt = new Date(
        Date.now() + CALLBACK_REQUEST_COOLDOWN_MS
      ).toISOString();
      this.loaded = true;
    },
  },
});
